export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conforme"])},
        "non_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non conforme"])}
      },
      "en": {
        "compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compliant"])},
        "non_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non compliant"])}
      }
    }
  })
}
